import { render, staticRenderFns } from "./CompaniesForm.vue?vue&type=template&id=e4891a82"
import script from "./CompaniesForm.vue?vue&type=script&lang=js"
export * from "./CompaniesForm.vue?vue&type=script&lang=js"
import style0 from "./CompaniesForm.vue?vue&type=style&index=0&id=e4891a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports